/**
 * 🏗 Returns the display value for a certain currency
 */
export function getCurrencyDisplayValue(val: number, showSign: boolean = true, currency: string = '$'): string {
  if (val > 0) return (showSign ? '+' : '') + currency + val.toFixed(2);
  if (val < 0) return (showSign ? '-' : '') + currency + (Number(val) * -1).toFixed(2);
  if (val === 0) return currency + val.toFixed(2);
  return '';
}

/**
 * Returns the indicator display string based on its value
 */
export function getIndicatorDisplayValue(val: number, showSign: boolean = true, showPercentage: boolean = true): string {
  if (val > 0) return (showSign ? '+' : '') + val.toFixed(2) + (showPercentage ? '%' : '');
  if (val < 0) return (showSign ? '-' : '') + (Number(val.toFixed(2)) * -1) + (showPercentage ? '%' : '');
  if (val === 0) return val.toFixed(2) + (showPercentage ? '%' : '');
  return '';
}